import styled from '@emotion/styled';

export const OrderCardContentWrapper = styled.div`
    width: 100%;
    display: flex;
    flex: 1 0 auto;
    flex-direction: column;
    padding: 16px;
    border-radius: 16px;
    border: 1px solid ${(props) => props.theme.colors.gray};
`;

export const OrderCardTimeSeparator = styled.div`
    width: 1px;
    height: 100%;
    flex: 0 0 auto;
    background-color: ${(props) => props.theme.colors.gray};
    /*margin: 0 16px;*/
`;